import { useContext, useEffect, useState } from "react";
import FormRendererContext from "../../services/context/FormRendererContext";

import "./common.scss";

const ContentRenderer = ({ data }) => {
  const { workflowContext } = useContext(FormRendererContext);
  
  // Function to replace handlebars-style variables with actual values
  const replaceVariables = (htmlString, context) => {
    if (!htmlString || !context) return htmlString;
    
    return htmlString.replace(/\{\{(\w+)\}\}/g, (match, variable) => {
      const value = context[variable];
      return value !== undefined ? value : match;
    });
  };
  
  const handleConditionalRendering = (container, context) => {
    const conditionalElements = container.querySelectorAll('[data-if]');
    
    conditionalElements.forEach(element => {
      const variable = element.getAttribute('data-if');
      const value = context[variable];
      
      if (value === undefined || value === null || value === '') {
        element.style.display = 'none';
      } else {
        element.style.display = '';
      }
    });
  };
  
  useEffect(() => {
    if (data.html) {
      const divId = "html-element" + data?.key;
      const container = document.getElementById(divId);
      
      if (container) {
        const processedHtml = replaceVariables(data.html, workflowContext);
        container.innerHTML = processedHtml;
        
        handleConditionalRendering(container, workflowContext);
      }
    }
  }, [data.html, data.key, workflowContext]);
  
  return (
    <>
      {data.html ? (
        <div className="content-renderer">
          <div
            id={"html-element" + data?.key}
            className={data?.customClass}
          ></div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default ContentRenderer;